module.exports = __webpack_public_path__ + "ac.no2.1aaca360.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/ac.no2.jpg
// module id = UKGs
// module chunks = 0